export const statusBoleto = {
  generated: 'ABERTO',
  underpaid: 'BAIXADO COM PENDÊNCIA',
  overpaid: 'BAIXADO COM PENDÊNCIA',
  paid: 'BAIXADO',
  canceled: 'CANCELADO',
  with_error: 'COM ERRO',
  failed: 'COM ERRO',
  processing: 'NÃO PROCESSADO',
  first_payment_canceled: 'CANCELADO - 1 PARCELA',
};
